import { AssertIsStringException } from './assert-is-string.exception';
import { isString } from '@pct-ts/typeguard';

export function assertIsString(value: unknown, message: string): asserts value is string {
  if (!isString(value)) {
    throw new AssertIsStringException(`Not a string: ${message}`);
  }
}
